// @ts-strict-ignore
import styled from 'styled-components';
import i18n from 'src/utils/translate';
import { useSelector } from 'src/store/store';
import SearchBar from 'src/modules/search/shared/components/searchBar';
import SearchResultsList from 'src/modules/search/posts/components/searchResultsList';
import SearchTips from 'src/modules/search/shared/components/searchTips';
import SearchNavbar from 'src/modules/search/shared/components/searchNavbar';
import SearchMembersResultsList from 'src/modules/community/communitySearch/components/searchMembersResultsList';
import { helpScoutArticle } from 'src/utils/helpScoutBeacon';
import Button from 'src/components/buttons/button';
import { SearchType } from 'src/constants/types';
import { useBranch } from 'src/utils/cookie';
import { useMediaQuery } from 'src/utils/mediaQuery';

type Props = {
  query: string;
  searchType: SearchType;
};
export default function CommunitySearchWrapper({ query, searchType }: Props) {
  const isMemberOfCommunity = useSelector(({ context }) => context.currentUser?.isCommunityMemberOrHUStaff) || false;
  const community = useSelector(({ context }) => context.currentCommunity);

  const isA = useBranch() !== 'B';
  const isDesktop = useMediaQuery('overScreenSmall');

  const placeholderForPosts = i18n.t('Search posts on ') + community?.name;
  const placeholderForMembers = i18n.t('Search members on ') + community?.name;
  const placeholderText = searchType === 'members' ? placeholderForMembers : placeholderForPosts;

  const searchResults = () => {
    switch (searchType) {
      case 'members':
        return <SearchMembersResultsList communitySlug={community?.slug} isMemberOfCommunity={isMemberOfCommunity} />;
      case 'posts':
      default:
        return <SearchResultsList isCommunitySearch={true} isMemberOfCommunity={isMemberOfCommunity} />;
    }
  };

  return (
    <div className="search">
      <Header>
        {(isA || isDesktop) && (
          <>
            <SearchBar
              autoFocus={true}
              disableAutosuggest={searchType === 'members'}
              isCommunitySearch={true}
              placeholder={placeholderText}
              searchType={searchType}
            />
            <StyledButton
              icon="open-right"
              iconLeftAligned={false}
              type="link"
              onClick={() => helpScoutArticle('139-different-types-of-search-on-healthunlocked')}
            >
              {i18n.t('Learn more about the search tool')}
            </StyledButton>
          </>
        )}
        <NavbarContainer>
          <SearchNavbar query={query} searchType={searchType} />
        </NavbarContainer>
      </Header>
      {query
        ? searchResults()
        : (
          <SearchTips
            communitySlug={community?.slug}
            isMemberOfCommunity={isMemberOfCommunity}
            isNoQuery={true}
            searchType={searchType}
          />
        )
      }
    </div>
  );
}

const Header = styled.div`
  margin-bottom: 40px;
  @media (${({ theme }) => theme.underScreenSmall}) {
    padding: 0 15px;
  }
`;

const StyledButton = styled(Button)`
  margin: 0;
`;

const NavbarContainer = styled.div`
  margin-top: 30px;
`;
